
export default function closeCard () {
  let cards = []

  if (document.querySelector('.custom-table')) {
    cards = document.querySelectorAll('.card')
    cards.forEach((card) => {
      card.classList.add('collapsed-card')
    })
  }
}
